import React from "react";
import { Link } from "react-router-dom";
import background from "../assets/background.webp"; // Если фоновая картинка тоже в assets
import logo_white from "../assets/logo-white.svg";
import { useTranslation } from "react-i18next";
const FacebookIcon = () => (

  <svg viewBox="0 0 24 24" className="w-[30px] h-[30px]" fill="currentColor">
    <path d="M22 12a10 10 0 10-11.5 9.9v-7H8v-3h2.5V9.5c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.8-1.6 1.6V12H17l-.4 3h-2.3v7A10 10 0 0022 12z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" className="w-[30px] h-[30px]" fill="currentColor">
    <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2c1.7 0 3 1.3 3 3v10c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V7c0-1.7 1.3-3 3-3h10zm-5 3.5A4.5 4.5 0 1016.5 12 4.5 4.5 0 0012 7.5zm0 2A2.5 2.5 0 1112 14.5 2.5 2.5 0 0112 9.5zM17.8 6.2a1 1 0 11-1 1 1 1 0 011-1z"/>
  </svg>
);

const YoutubeIcon = () => (
  <svg viewBox="0 0 24 24" className="w-[30px] h-[30px]" fill="currentColor">
    <path d="M23 12s0-3.6-.5-5.3a3 3 0 00-2.1-2.1C18.6 4 12 4 12 4s-6.6 0-8.4.6A3 3 0 001.5 6.7C1 8.4 1 12 1 12s0 3.6.5 5.3a3 3 0 002.1 2.1C5.4 20 12 20 12 20s6.6 0 8.4-.6a3 3 0 002.1-2.1C23 15.6 23 12 23 12zM10 15V9l5 3-5 3z"/>
  </svg>
);

const WhatsappIcon = () => (
  <svg 
    viewBox="0 0 24 24" 
    className="w-[30px] h-[30px] block" 
    fill="currentColor" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.472 14.382c-.301-.15-1.767-.867-2.04-.966-.273-.101-.473-.15-.673.15-.197.295-.771.964-.944 1.162-.175.199-.349.223-.651.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.777-1.66-2.074-.174-.3-.018-.465.13-.613.137-.133.301-.351.452-.527.149-.174.198-.298.299-.497.102-.199.05-.372-.025-.521-.075-.148-.672-1.622-.922-2.227-.244-.588-.493-.507-.672-.516-.174-.007-.373-.008-.573-.008-.2 0-.523.074-.797.374-.273.3-1.045 1.02-1.045 2.487 0 1.468 1.068 2.885 1.218 3.084.15.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.76-.719 2.008-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.412h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.432 5.628 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

const Footer = () => {

  const { t } = useTranslation();

  const siteMap = [
    { text: t("footer_team"), link: "/team" },
    { text: t("footer_jobs"), link: "/jobs" },
    { text: t("footer_certs"), link: "/certificates" },
    { text: t("footer_videos"), link: "/videos" },
  ];
  const social = [
    { Icon: FacebookIcon, href: "https://www.facebook.com/solarholdingArmenia" },
    { Icon: InstagramIcon, href: "https://www.instagram.com/solar_holding/" },
    { Icon: YoutubeIcon, href: "https://www.youtube.com/@SolarHolding" },
    { Icon: WhatsappIcon, href: "https://wa.me/+37477122159" },
  ];

 return (
    <footer className="w-full bg-[#0058a3] flex flex-col items-center" style={{ backgroundImage: `url(${background})` }}>
      {/* TOP */}
      <div className="w-full flex flex-wrap justify-evenly max-sm:justify-start items-start py-[50px]">
        <img src={logo_white} alt="Logo" className="w-[250px] object-contain" />

        {/* CONTACT */}
        <div className="w-[320px] m-[15px] flex flex-col">
          <h2 className="text-white uppercase font-light font-['Cormorant_Garamond']">
            {t("footer_contacts")}
          </h2>
          <div className="mt-[15px] space-y-4">
            <p className="text-white text-[18px] leading-[30px] font-['Cormorant_Garamond']">
              {t("footer_address")}
            </p>
            <div className="flex">
              <span className="text-yellow-500 mr-2 tracking-[2px]">A:</span>
              <a href="mailto:solarholdingsp@gmail.com" className="text-white hover:text-yellow-500 transition">
                solarholdingsp@gmail.com
              </a>
            </div>
            <div className="flex">
              <span className="text-yellow-500 mr-2 tracking-[2px]">T:</span>
              <a href="tel:+37477222673" className="text-white hover:text-yellow-500 transition">
                (+374)77 222-673
              </a>
            </div>
          </div>
        </div>

        {/* FAQ / MAP */}
        <div className="w-[320px] m-[15px] flex flex-col">
          <h2 className="text-white uppercase font-light font-['Cormorant_Garamond']">
            {t("footer_map")}
          </h2>
          <ul className="mt-[15px] space-y-[15px]">
            {siteMap.map((item, i) => (
              <li key={i}>
                <Link to={item.link} className="text-white hover:text-yellow-500 transition">
                  {item.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* SOCIAL (оставляем как есть, так как это иконки) */}
      <div className="w-full flex justify-center border-t border-yellow-500 py-5">
        <ul className="flex gap-3">
          {social.map((item, i) => (
            <li key={i} className="w-[50px] h-[50px] overflow-hidden flex items-center justify-center border border-yellow-500 rounded-full text-yellow-500 transition-all duration-300 hover:bg-yellow-500 hover:text-white">
              <a href={item.href} className="flex items-center justify-center w-full h-full" target="_blank" rel="noreferrer noopener">
                <item.Icon />
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* COPYRIGHT */}
      <div className="py-5 text-yellow-500 tracking-[2px] md:tracking-[4px] text-[12px] md:text-[14px] text-center px-4">
        SOLAR HOLDING LLC © 2026 {t("footer_rights")}
      </div>
      <div className="pb-5 text-yellow-500 tracking-[2px] md:tracking-[4px] text-[12px] md:text-[14px] text-center px-4">
        Կայքը ստեղծվել է <a href="https://timetocode.vercel.app" className="text-white hover:text-yellow-300 transition" target="_blank" rel="noreferrer">TimeToCode Ծրագրավորման կենտրոնի</a> կողմից
      </div>
    </footer>
  );
};

export default Footer;